export default {
  null_option: 'Ohne {{name}}',
  description: 'Wähle dein {{name}}',
};
